const carouselConfig = {
  slidesPerView: 1,
  displayDots: false,
  full_width: false,
  spaceBetween: 0,
  centeredSlides: false,
  breakpoints: {
    640: {
      // when window width is >= 640px
      slidesPerView: 3,
    },
  },
};
export default carouselConfig;
